
const Preloader = () => {

    return (
        <div
            id="preloader"
            className="fixed inset-0 flex items-center justify-center bg-gray-100 z-50"
        >
            <div className="text-center">
                <img
                    src={`https://mindcoders.in/assets/img/fevicon 01.webp`}
                    alt="logo"
                    className="w-24 h-24 mb-4"
                    style={{ opacity: 0.8 }}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default Preloader;
